import React, { useEffect, useRef, useState } from "react";
import { CornerUpRight } from "../../icons/CornerUpRight";
import { Bookmark1 } from "../../icons/Bookmark1";
import { Star011 } from "../../icons/Star011";
import { Clock, Map, Phone1 } from "../../icons/IconCollection";
import { Globe } from "../../icons/Globe";
import { fetchStores } from "../../ServerCall";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import {
  getDirectionUrl,
  getDirectionUrlFromCoordinates,
  getDirectionUrlWithNameAndAddress,
  getOpeningMessage,
  openExtUrl,
  sendAnalyticsToGA,
  toastObj,
} from "../../utils/commanFunctions";
import { Link } from "react-router-dom";
import Spinner from "../spinner/Spinner";
import { Header } from "../common/Header";
import { Bookmark } from "../common/BookMarkIcons/Bookmark";
import { Bookmark3 } from "../../icons/Bookmarks3";
import HeartIconDetailsPage from "../../icons/HeartIconDetailsPage";
import Home from "../Home/Home";
import ImageComponent from "../Trip/ImageComponent";
import StoreAccordion from "../Accordion/StoreAccordion";
import { trackCTA, trackFavorited } from "../../utils/FunctionsForGa";

const DetailNew = ({ id, goBackToParent = null }) => {
  const [singleStore, setSingleStore] = useState({});
  const [selectedImage, setSelectedImage] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [callFromParent, setCallFromParent] = useState(null);
  const is_embedded_in_parent = localStorage.getItem("is_embedded_in_parent");
  const isBookmarked = () => {
  const bookMData = JSON.parse(localStorage.getItem("tripBookmarked")) || { ids: [] };
  return bookMData.ids.includes(singleStore.id);
};

  const platform = /android/i.test(navigator.userAgent)
    ? "android"
    : /iPhone|iPad|iOS/i.test(navigator.userAgent)
    ? "ios"
    : "web";


//     useEffect(() => {
//   const isPersonalized = sessionStorage.getItem("fromPersonalized");
//   if (isPersonalized === "true") {
//     console.log("User came from personalized page");
//     sessionStorage.removeItem("fromPersonalized");
//   }
// }, []);


    






  useEffect(() => {
    (async () => {
      if (id) {
        try {
          setIsLoading(true);
          let data = await fetchStores(null, null, null, id);
          if (data.status) {
            setSingleStore(data.data);
            if (data.data?.images?.length > 0)
              setSelectedImage(data.data?.images[0]);
          } else {
            console.log(data);
            toast.error("Data is not available", toastObj);
          }
        } catch (error) {
          console.error("Error fetching store details:", error);
          toast.error("Failed to fetch store details", toastObj);
        } finally {
          setIsLoading(false); // Set loading to false after fetch
        }
      }
    })();
  }, [id]);

  const handleRedirect = (url) => {
    navigate(url);
  };




  // If loading, return the spinner
  // if (isLoading) {
  //   return <Spinner fullScreen={true} color="black" />;
  // }


  return (
    <Home>
      <Header
        data={{
          title:
            singleStore?.name?.length > 25
              ? singleStore.name.slice(0, 22) + "..."
              : singleStore?.name,
          ...(goBackToParent ? { goBackToParent: window.GoBackToParent } : {}),
        }}
        showFilter={false}
        showSearch={false}
        showBookMark={false}
        intialFetch={false}
      />

      {isLoading ? (
        <Spinner fullScreen={true} color="black" />
      ) : (
        <div className="flex max-w-[1000px] mx-auto flex-col w-[100%] items-start pb-[100px] px-0 relative bg-white overflow-hidden page-color">
          {singleStore.images?.length > 0 ? (
            <div className="flex flex-col h-[393px] items-start relative self-stretch w-full large-image">
              <ImageComponent
                imageUrl={
                  selectedImage?.image || "https://placehold.co/600x400"
                }
                passedClasses={
                  "details-page-image flex items-end gap-2 relative flex-1 self-stretch w-full grow bg-[#00000033]"
                }
                focalPoint={selectedImage?.image_metadata?.focus_point}
              >
                <div className=" flex flex-col items-center  py-4 gap-3 box-border bg-[#0000007a] z-0 w-full mini-image">
                  <div className="flex items-center overflow-x-scroll w-full pl-4 gap-2 pr-3 ">
                    {singleStore?.images.map((e, i) => {
                      const isSelected = e.id === selectedImage.id;
                      return (
                        <div
                          key={i}
                          onClick={(event) => {
                            event.stopPropagation();
                            if (!isSelected) setSelectedImage(e);
                          }}
                          className={`flex-shrink-0 relative w-[84px] h-[56px]  cursor-pointer  z-20  ${
                            isSelected ? " w-[93px] h-[62px] " : ""
                          } screen-border`}
                        >
                          <ImageComponent
                            imageUrl={e?.image}
                            passedClasses={`w-full h-full object-cover border-solid border border-white rounded-[5px] ${
                              isSelected ? " " : " "
                            }`}
                          />
                          {!isSelected && (
                            <div className="absolute top-0 left-0 w-full h-full bg-[#0000003e] rounded-[5px] pointer-events-none" />
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex justify-center gap-1">
                    {singleStore?.images.map((e, i) => {
                      const isSelected = e.id === selectedImage.id;
                      return (
                        <div
                          key={i}
                          className={`w-2 h-2 rounded-full border ${
                            isSelected
                              ? "bg-white border-white"
                              : "bg-transparent"
                          }`}
                        />
                      );
                    })}
                  </div>
                </div>
              </ImageComponent>
              {/* <div
          style={{
              backgroundImage: `url(${selectedImage?.image || "https://placehold.co/600x400"})`,
              backgroundColor: "rgb(238, 238, 238)",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          className="flex items-end gap-2 relative flex-1 self-stretch w-full grow bg-[#00000033]">
          <div className="flex items-start gap-2 p-4 relative flex-1 grow bg-[#0000004c] overflow-x-scroll mini-image">
        
  
   {
     singleStore?.images.map((e,i)=>{
     return <img key={i}
     onClick={(event)=>{
      event.stopPropagation()
      if(e.id!== selectedImage.id)
          setSelectedImage(e)
     }}
      className={`relative w-[84px] h-14 object-cover ${e.id===selectedImage.id ? "border-solid border-2 border-black":""} screen-border`}
      alt="Image"
      src={e?.image}
    />
     }) 
   }
          </div>
        </div> */}
            </div>
          ) : (
            <div className="flex flex-col h-[393px] items-start relative self-stretch w-full large-image">
              <div
                style={{
                  backgroundImage: `url("https://placehold.co/600x400?text=No+Image+Available")`,
                  backgroundColor: "rgb(238, 238, 238)",
                  backgroundSize: "cover",
                  backgroundPosition: "center center",
                }}
                className="flex items-end gap-2 relative flex-1 self-stretch w-full grow bg-[#00000033]"
              >
                <div className=" items-start gap-2 p-4 relative flex-1 grow bg-[#0000004c] overflow-x-scroll mini-image hidden"></div>
              </div>
            </div>
          )}

          <div className="flex flex-col items-center justify-center gap-2 p-4 relative self-stretch w-full flex-[0_0_auto]">
            <div className="flex items-center gap-2 relative self-stretch w-full flex-[0_0_auto] overflow-x-scroll ">
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  const url =
                    singleStore.source === null
                      ? getDirectionUrlFromCoordinates(
                          singleStore.latitude,
                          singleStore.longitude
                        )
                      : getDirectionUrlWithNameAndAddress(
                          singleStore.name,
                          singleStore.address
                        );

                  trackCTA({
                    action: "direction_lookup",
                    isFavorite: isBookmarked(),
                    storeName: singleStore?.name || "details page",
                  });
                  openExtUrl(url, "_system");
                }}
                className="flex flex-col items-start gap-2 p-[18px] relative flex-1 grow bg-[#f6f6f6] rounded-lg cursor-pointer store-tab"
              >
                <div className="store-tab-directions">
                  <CornerUpRight className="!relative !w-6 !h-6" />
                  <div className="relative w-fit font-secondary font-normal text-wwwstanfordcourtcomblack text-sm tracking-[-0.32px] leading-[normal] mt-[7px]">
                    Directions
                  </div>
                </div>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  const action = isBookmarked() ? "removed" : "added"
                  trackFavorited({
                    action: action,
                    name:singleStore.name,
                    store_id: singleStore.id
                  });
                  setCallFromParent((prev) => !prev);
                }}
                className="flex flex-col items-start gap-1 p-[18px] relative flex-1 grow bg-[#f6f6f6] rounded-lg cursor-pointer store-tab"
              >
                <Bookmark
                  className="!p-1.5 rounded-md cursor-pointer heart-icon-details-page"
                  icon={
                    <HeartIconDetailsPage className="!relative !w-6 !h-6" />
                  }
                  stateProp="default"
                  id={singleStore.id}
                  name={singleStore.name}
                  callFromParent={callFromParent}
                  isBookmarked={isBookmarked}
                />
                <div className="store-tab-bookmark-text relative w-fit font-secondary font-normal text-wwwstanfordcourtcomblack text-sm tracking-[-0.32px] leading-[normal]">
                  Favorite
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start gap-2 pt-4 pb-6 px-4 relative self-stretch w-full flex-[0_0_auto]">
            <div className="relative self-stretch mt-[-1.00px] font-secondary font-normal text-wwwstanfordcourtcomblack text-[32px] tracking-[0] leading-8 single-store-heading">
              {singleStore.name}
            </div>

            <div className="inline-flex items-center gap-1 relative flex-[0_0_auto]">
              <Star011 className="!relative !w-4 !h-4" />
              <p className="relative w-fit mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5 whitespace-nowrap">
                <span className="font-secondary single-store-rating font-normal text-[#231f20] text-sm tracking-[0] leading-5">
                  {singleStore.rating} ({singleStore.reviews_count || 0}{" "}
                  reviews)
                </span>
              </p>
            </div>

            <p className="relative self-stretch font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] whitespace-pre-line leading-5 single-store-description">
              {singleStore.description}
            </p>
          </div>

          <div className="flex flex-col items-center justify-center gap-2 pt-0 pb-6 px-4 relative self-stretch w-full flex-[0_0_auto]">
            <div className="flex details-bottom-card-container flex-col items-start relative self-stretch w-full flex-[0_0_auto]">
              {/*  Opening Hours */}
              {(singleStore?.open_now !== null &&
                singleStore?.open_now !== undefined) ||
              (Array.isArray(singleStore?.opening_hours?.weekdayDescriptions) &&
                singleStore.opening_hours.weekdayDescriptions.length > 0) ? (
                <StoreAccordion singleStore={singleStore} />
              ) : null}

              {/* {(
                <div className="flex items-start gap-4 relative self-stretch w-full flex-[0_0_auto] details-bottom-card">
                  <div className="flex w-6 h-12 items-center gap-2 relative details-bottom-card-icon-div">
                    <Clock className="!relative !flex-1 !grow !h-6" />
                  </div>

                  <div className="flex items-center justify-center gap-2 px-0 py-4 relative flex-1 grow border-b [border-bottom-style:solid] border-wwwstanfordcourtcommercury details-bottom-card-text">
                    <p
                      className={`relative flex-1 mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5 ${
                        singleStore?.open_now ? "store-open" : "store-closed"
                      }`}
                    >
                      {singleStore?.open_now ? "OPEN" : "CLOSED"}
                      {!singleStore?.open_now &&
                        typeof singleStore.opening_hours === "object" &&
                        singleStore.opening_hours?.weekdayDescriptions?.length >
                          0 &&
                        getOpeningMessage(singleStore.opening_hours)}
                    </p>
                  </div>
                </div>
              )} */}

              {singleStore.phone_number && (
                <Link
                  className="telephone-link"
                  to={`tel:${
                    singleStore.phone_number.startsWith("+")
                      ? singleStore.phone_number
                      : `+${singleStore.phone_number}`
                  }`}
                >
                  <div onClick={() => {
        trackCTA({
          action: "contact_clicked",
          isFavorite: isBookmarked(),
          storeName: singleStore?.name || "details page",
        });
      }} className="cursor-pointer flex items-start gap-4 relative self-stretch w-full flex-[0_0_auto] details-bottom-card">
                    <div className="flex w-6 h-12 items-center gap-2 relative details-bottom-card-icon-div">
                      <Phone1 className="!grow !h-6 !relative !flex-1" />
                    </div>

                    <div className="flex items-center justify-center gap-2 px-0 py-4 relative flex-1 grow border-b [border-bottom-style:solid] details-bottom-card-text border-wwwstanfordcourtcommercury">
                      <div className="mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5 relative flex-1">
                        {singleStore.phone_number.startsWith("+")
                          ? singleStore.phone_number
                          : `+${singleStore.phone_number}`}
                      </div>
                    </div>
                  </div>
                </Link>
              )}

              {singleStore?.address && (
                <div className="flex items-start gap-4 relative self-stretch w-full flex-[0_0_auto] details-bottom-card">
                  <div className="flex w-6 h-12 items-center gap-2 relative details-bottom-card-icon-div">
                    <Map className="!relative !flex-1 !grow !h-6" />
                  </div>

                  <div className="flex flex-col items-center justify-center gap-6 px-0 py-4 relative flex-1 grow border-b [border-bottom-style:solid] border-wwwstanfordcourtcommercury details-bottom-card-text">
                    <p className="relative self-stretch mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5">
                      {singleStore?.address}
                    </p>

                    {singleStore?.map_image && (
                      <div
                        style={{
                          backgroundImage: `url(${singleStore?.map_image})`,
                          backgroundColor: "rgb(238, 238, 238)",
                          backgroundSize: "cover",
                          backgroundPosition: "center center",
                        }}
                        className="relative self-stretch w-full h-[321px] rounded-lg border border-solid border-[#0000001a]"
                      />
                    )}
                  </div>
                </div>
              )}

              {singleStore?.source_page_url && (
                <div className="flex items-start gap-4 relative self-stretch w-full flex-[0_0_auto] details-bottom-card">
                  <div className="flex w-6 h-12 items-center gap-2 relative details-bottom-card-icon-div">
                    <Globe className="!relative !flex-1 !grow !h-6" />
                  </div>

                  <div className="cursor-pointer flex items-center justify-start gap-2 px-0 py-4 relative flex-1 grow border-b [border-bottom-style:solid] border-wwwstanfordcourtcommercury details-bottom-card-text">
                    <div
                      className="details-bottom-card-urls"
                      onClick={(e) => {
                        e.stopPropagation();
                        trackCTA({
                          action: "website_visited",
                          isFavorite: isBookmarked(),
                          storeName: singleStore?.name || "details page"
                        });

                        openExtUrl(singleStore.source_page_url, "_system");
                      }}
                    >
                      <div
                        style={{
                          overflowWrap: "anywhere",
                        }}
                        className="relative  flex-1 mt-[-1.00px] font-secondary font-normal text-virginhotelscomthunder text-sm tracking-[0] leading-5"
                      >
                        {singleStore?.source_page_url}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {(singleStore.tickets_url || singleStore.source_page_url) && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                openExtUrl(
                  singleStore.tickets_url || singleStore.source_page_url,
                  "_system"
                );
              }}
              className=" p-[10px] w-[100%]"
              style={{
                marginBottom: is_embedded_in_parent ? "35px" : "20px",
              }}
            >
              <div className="flex flex-col w-[100%] p-[10px] items-center justify-end bg-black border-t-[0.5px] [border-top-style:solid] border-[#0000001a] learn-more-btn">
                <div
                  to={singleStore.tickets_url || singleStore.source_page_url}
                  className="no-underline"
                >
                  <button className="all-[unset] box-border relative w-fit font-secondary font-normal text-white text-lg tracking-[0] leading-[20.7px] whitespace-nowrap">
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </Home>
  );
};

export default DetailNew;
